<template>
	<span>

		<a
			v-if="active && active === 'asc'"
			@click="order(null)"
		>
			{{ title || index || '???' }}

			<fa-icon
				class="ml-2 text-primary"
				:class="$style.icon"
				icon="sort-up"
			/>
		</a>

		<a
			v-else-if="active && active === 'desc'"
			@click="order('asc')"
		>
			{{ title || index || '???' }}

			<fa-icon
				class="ml-2 text-primary"
				:class="$style.icon"
				icon="sort-down"
			/>
		</a>

		<a
			v-else
			@click="order('desc')"
		>
			{{ title || index || '???' }}

			<fa-icon
				class="ml-2 text-muted"
				:class="$style.icon"
				icon="sort"
			/>
		</a>

	</span>
</template>

<script>

export default {
	name: 'GTableFilterOrder',
	props: {
		title: {
			type: String,
			required: true
		},
		index: {
			type: String,
			required: true
		},
		view: {
			type: String,
			required: true
		}
	},
	data() {
		return {
			value: ''
		};
	},
	computed: {
		query() {
			return this.$query(this.view);
		},
		active() {
			if (this.query.orders && this.query.orders[this.index]) return this.query.orders[this.index];
			return false;
		}
	},
	watch: {
		active(val) {
			if (!val) this.value = '';
		}
	},
	created() {
		if (this.active) this.value = this.active.value;
	},
	methods: {
		order(value = null) {
			if (value) {
				this.query.order.add({ field: this.index, value });
			} else {
				this.query.order.delete(this.index);
			}
		}
	}
};
</script>

<style lang="scss" module>
	.icon{
		font-size: 12px;
	}
</style>
